import type { RequestParams } from '@/shared/api';

export const COMPANY_KEYS = {
  all: ['company'] as const,
  list: (params?: RequestParams) => [...COMPANY_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...COMPANY_KEYS.all, 'detail', id] as const,
};
